import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useNavigationType,
} from 'react-router';
import { useLocation } from 'react-router-dom';
import { App } from './App';

if (__JS_ENV_VARS__['JS_ENV_SENTRY_DSN']) {
  Sentry.init({
    dsn: __JS_ENV_VARS__['JS_ENV_SENTRY_DSN'] as string,
    environment:
      (__JS_ENV_VARS__['JS_ENV_SENTRY_ENVIRONMENT'] as string) ?? 'local',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
    ],
    tracesSampleRate: 0.2,
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />,
);
